/**
 * Homepage functionality
 */
import { t } from './i18n';

export function initHomePage() {
    const tabs = document.querySelectorAll('.qtab');
    const form = document.getElementById('home-search-form');
    const filtersBody = document.getElementById('filters-body');

    if (!form || !filtersBody) return;

    const searchBtnText = document.getElementById('search-btn-text');
    const rankLabelText = document.getElementById('rank-label-text');
    const roleLabelText = document.getElementById('role-label-text');
    const createBtn = form.querySelector('.btn-create');
    const filterSelects = filtersBody.querySelectorAll('select.filter-select');

    // Queue tabs switching
    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            // Update active tab
            tabs.forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            // Update form action
            const action = this.dataset.action;
            form.action = action;

            // Update queue type for CSS
            const queue = this.dataset.queue;
            filtersBody.dataset.queue = queue;

            // Update button, rank and role label text
            const isTeams = queue === 'teams';

            // The create button opens the form of the picked queue
            if (createBtn) {
                createBtn.href = this.dataset.create;
                createBtn.dataset.ctaType = isTeams ? 'team' : 'party';
            }
            if (searchBtnText) searchBtnText.textContent = t(isTeams ? 'Найти команду' : 'Найти напарника');
            if (rankLabelText) rankLabelText.textContent = rankLabelText.dataset[isTeams ? 'teams' : 'default'];
            if (roleLabelText) roleLabelText.textContent = roleLabelText.dataset[isTeams ? 'teams' : 'default'];

            // Update empty option text in Tom Select instances
            filterSelects.forEach(select => {
                const emptyOpt = select.querySelector('option[value=""]');
                if (!emptyOpt) return;
                const newText = emptyOpt.dataset[isTeams ? 'teams' : 'default'];
                emptyOpt.textContent = newText;
                if (select.tomselect) {
                    select.tomselect.updateOption('', { value: '', text: newText });
                    // Refresh display if empty option is selected
                    if (select.tomselect.getValue() === '') {
                        select.tomselect.refreshItems();
                    }
                }
            });
        });
    });

    // Role buttons toggle
    document.querySelectorAll('.rf-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            this.classList.toggle('active');
            const checkbox = this.querySelector('input[type="checkbox"]');
            checkbox.checked = this.classList.contains('active');
        });
    });
}

// Auto-init on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initHomePage);
